import { useQuery } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import type {
    ApiError,
    InteractionListParams,
    InteractionListResponse,
} from '@app/services/api.types';

type QueryOptions = Omit<
    UseQueryOptions<InteractionListResponse, ApiError>,
    'queryKey' | 'queryFn'
>;

export const fetchInteractionList = async (
    params: InteractionListParams,
    signal?: AbortSignal
): Promise<InteractionListResponse> => {
    const url = apiEndpoints.interactions.getList(params);
    const response = await api.get(url, { signal });
    return response?.data?.data;
};

const useInteractionList = (params: InteractionListParams, options?: QueryOptions) => {
    return useQuery<InteractionListResponse, ApiError>({
        queryKey: ['interaction', 'list', params],
        queryFn: ({ signal }) => fetchInteractionList(params, signal),
        ...options,
    });
};

export default useInteractionList;
